import React, { useEffect, useState } from 'react'
import Layout from 'Layout'
import RoomChat from './RoomChat'
import { useNavigate, useParams } from 'react-router-dom'
import { mixGetV1 } from 'services/mixin'

const Dashboard: React.FC = () => {
    // Phải đặt là slug vì bên App khi báo là slug
    const { slug } = useParams()
    const navigate = useNavigate()
    const [numberAccount, getNumberAccount] = useState('')
    const [showModal, setShowModal] = useState(false);
    const [modelChatDetail, setModelChatDetail] = useState({})
    const [idModel, setIDModel] = useState(-1)

    const saveLocal = () => {
        localStorage.setItem('account_number', numberAccount)
        navigate('/account-live-metrix')
    }

    const getModelChatDetail = async (slug: any) => {
        try {
            const res = await mixGetV1(`/api/v1/fe/model_chat/${slug}`)

            if (res.status) {
                setModelChatDetail(res.data)
                setIDModel(res.data.id)
            }
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        getModelChatDetail(slug)
    }, [])

    return (
        <Layout>
            <div id="lqd-titlebar" className="lqd-titlebar pt-6 pb-7 border-b transition-colors max-[991px]:!pt-[16px] max-[991px]:!pb-[16px]" layout-wide="">
                <div className="lqd-titlebar-container flex flex-wrap items-center justify-between gap-y-4 container">
                    <div className="lqd-titlebar-col lqd-titlebar-col-nav group/titlebar-nav flex w-full flex-col gap-2 lg:w-7/12">
                        <p className="lqd-titlebar-pretitle text-xs text-foreground/70 m-0 table-none">
                            <a
                                className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-link bg-transparent hover:underline hover:translate-y-0 hover:shadow-none focus-visible:underline p-0 focus-visible:translate-y-0 focus-visible:shadow-none focus-visible:outline-0 lqd-btn-size-none lqd-btn-hover-none text-inherit hover:text-foreground"
                                href="/"
                            >
                                <svg stroke-width="1.5" className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M15 6l-6 6l6 6"></path>
                                </svg>
                                Back to dashboard
                            </a>
                        </p>
                        <h1 className="lqd-titlebar-title m-0">
                            {modelChatDetail?.name || ''}
                        </h1>
                        <p className="lqd-titlebar-subtitle mt-1 text-2xs opacity-80 only:my-0 last:mb-0">
                            {modelChatDetail?.content || 'AI Chat Images'}
                        </p>
                    </div>

                    {/* <div className="lqd-titlebar-col lqd-titlebar-col-actions group/titlebar-actions max-lg:has-[.max-lg\:hidden:only-child]:hidden flex w-full flex-wrap gap-y-3 lg:w-5/12 lg:justify-end">
                        <div className="lqd-titlebar-actions flex flex-wrap items-center gap-2">
                            <a
                                className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-xl disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-primary bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-primary/10 focus-visible:bg-primary/90 focus-visible:shadow-primary/10 lqd-btn-md py-2 px-4 lqd-btn-hover-none"
                                href="#"
                            >
                                <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M12 5l0 14"></path>
                                    <path d="M5 12l14 0"></path>
                                </svg>
                                New
                            </a>
                        </div>
                    </div> */}
                </div>
            </div>
            <RoomChat idModel={idModel} modelChatDetail={modelChatDetail} />
        </Layout>
    )
}
export default Dashboard